import React from "react"
import { useNavigate } from "react-router"
import { SUBSCRIPTION_PATH } from "@shared/constants/navigation"

const CProShield = () => {
  const navigate = useNavigate()

  const handleClick = (e: React.MouseEvent) => {
    e.stopPropagation()
    e.preventDefault()
    e.nativeEvent.stopImmediatePropagation()
    navigate(SUBSCRIPTION_PATH)
  }

  return (
    <button
      type="button"
      onClick={handleClick}
      onMouseDown={(e) => e.stopPropagation()}
      onMouseUp={(e) => e.stopPropagation()}
      className="uppercase text-[10px] font-sfPro font-bold text-white py-[3px] px-[7px] bg-[#92BC3D] hover:bg-[#A5CC5A] rounded-[6px] cursor-pointer inline-block"
    >
      pro
    </button>
  )
}

export default CProShield
